import React from "react";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";
import { BeatLoader } from "react-spinners";

const MobileNextButton = ({
  nextPage = null,
  nextPageAction = null,
  nextPageEnabled = true,
  nextPageLoading = false
}) => {
  const { actions, state } = useStateMachineWrapper();
  // We want to show the component when headerVisible is false
  const isVisible = true;//!state.session.headerVisible; 
  const canScroll =  state.session.canScrollHeaderOut;

  const goNext = async () => {
    console.log(nextPage, nextPageEnabled, nextPageAction);
    if (!nextPageEnabled) return;

    let shouldProceed = true;
    try {
      shouldProceed = await nextPageAction();
    } catch (e) {
      // Handle error if necessary
    }
    if (shouldProceed === false) return;

    if (nextPage != null && typeof nextPage === "string") {
        const target = document.getElementById('i3buyflow');
        //window.scrollTo({ top: 0, behavior: "smooth" });
        target.scrollIntoView({ behavior: "smooth" });
      actions.setPage(nextPage);

    }
  };

  return (
    <>
    
      {/* Inline CSS for the transition properties */}
      <style>{`
        .slide-container {
          overflow: hidden;
          transition: max-height 200ms ease-in-out, opacity 300ms ease-in-out, transform 300ms ease-in-out;
        }
      `}</style>

      {/* The container is always rendered. Its inline style changes based on isVisible */}
      <div
        className="slide-container"
        style={{
          maxHeight: isVisible ? "111px" : "0",
          opacity: isVisible ? "1" : "0",
          transform: isVisible ? "translateY(0)" : "translateY(0px)"
        }}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <div
            className="flex-none w-14"
            style={{ marginTop: "33px", marginBottom: "30px", width: "275px" }}
          >
            <div
              className="cursor-pointer text-yellow hover:text-yellow-600"
              style={{ textAlign: "center" }}
            >
              <div className={`rounded-full self-center py-2 px-6 cursor-pointer font-bold ${nextPageEnabled ? "bg-purple" : "bg-gray"} text-white hover:bg-purple-600 text-2xl`}>
                {nextPageLoading !== false ? (
                  <div>
                    <BeatLoader
                      className="mx-auto mt-1"
                      size={"1rem"}
                      color={"#FFFFFF"}
                      speedMultiplier={0.75}
                    />
                  </div>
                ) : (
                  nextPage !== null && <div onClick={goNext}>Next</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileNextButton;
